/**
 * The Lead form function
 */
(function($) {
    const form = $('.mod24LeadForm form');
    if (form.length > 0) {

        if (form.data('erstinfo')) {
            $(document).ready(function() {
                window.c24.lp.overlay.showErstinfoOverlay(form);
            });
        }

        const updateFieldFunction = function() {
            $.each($('.question[data-if-field]', form), function() {
                const $this = $(this);
                const questionWrapper = $this.closest('.question');
                const fieldValue = $('input[name=' + $this.data('if-field') + '][type=radio]:checked,select[name=' + $this.data('if-field') + ']', form).val();
                const dataInv = $this.data('if-inv');
                const dataValue = $this.data('if-value');
                if ((dataInv === false && fieldValue === dataValue) ||
                    (dataInv === true && fieldValue !== dataValue)) {
                    if (!questionWrapper.is(':visible')) {
                        questionWrapper.stop().slideDown('low');
                    }
                } else {
                    if (questionWrapper.is(':visible')) {
                        questionWrapper.stop().slideUp('slow');
                    }
                }
            });
        };
        updateFieldFunction();
        $('select,input[type=radio]').on('change', updateFieldFunction);

        form.on('submit c24Submit', function(e) {
            e.preventDefault();

            const form = $(e.target);
            const modDiv = form.closest('.mod24LeadForm');
            const mailsent = $('.mailsent', modDiv);
            let invalidForm = false;
            const emailReg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[.a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,6})$/;
            const phoneReg = /^[0-9]{6,15}$/;

            if (form.data('erstinfo') && !form.data('erstinfo-done')) {

                $('.js24LoadingAction', form).removeClass('is-loading');

                window.c24.lp.overlay.showErstinfoOverlay(form, function () {
                    form.trigger('c24Submit');
                });

                return;
            }

            $.each($('.question div.errormessage', form), function() {
                const error = $(this);
                const question = error.closest('.question');
                const textInputs = $('input[type=text], textarea', question);
                const radioInputs = $('input[type=radio]', question);
                const selects = $('select', question);
                if (question.is(':visible')) {
                    if (textInputs.length !== 0) {
                        let hasInvalidField = false;
                        if (textInputs.hasClass('email')) {
                            hasInvalidField = textInputs.val() === '' || !emailReg.test(textInputs.val());
                            if (hasInvalidField) {
                                textInputs.addClass('error');
                            } else {
                                textInputs.removeClass('error');
                            }

                        } else if (textInputs.hasClass('phone')) {
                            hasInvalidField = textInputs.val() === '' || !phoneReg.test(textInputs.val().replace(' ', ''));
                            if (hasInvalidField) {
                                textInputs.addClass('error');
                            } else {
                                textInputs.removeClass('error');
                            }

                        } else {
                            $.each(textInputs, function() {
                                const input = $(this);
                                if (input.val() === '') {
                                    input.addClass('error');
                                    hasInvalidField = true;
                                } else {
                                    input.removeClass('error');
                                }
                            });
                        }
                        if (hasInvalidField) {
                            error.show();
                            invalidForm = true;
                        } else {
                            error.hide();
                        }
                    } else if (radioInputs.length !== 0) {
                        if (radioInputs.filter(':checked').length === 0) {
                            error.show();
                            radioInputs.closest('.c24-fe-radio').addClass('error');
                            invalidForm = true;
                        } else {
                            radioInputs.closest('.c24-fe-radio').removeClass('error');
                            error.hide();
                        }
                    } else if (selects.length !== 0) {
                        if (selects.val() === '0') {
                            error.show();
                            selects.addClass('error');
                            invalidForm = true;
                        } else {
                            selects.removeClass('error');
                            error.hide();
                        }
                    }
                }
            });

            if (invalidForm) {
                $('.js24LoadingAction', form).removeClass('is-loading');
            } else {
                form.hide();
                mailsent.removeClass('c24Hidden');
                $('.progress .step1', modDiv).removeClass('active');
                $.post(
                    form.data('path') + 'api/?k=24&a=leadform',
                    form.serialize(),
                    function(data) {
                        $('.div24Loading', mailsent).hide();
                        if (data.success) {
                            $('ul.success', mailsent).show();
                            let customUrl = document.URL;
                            const abParameter = customUrl.indexOf('?') >= 0 ? '&' : '?';
                            customUrl += abParameter + 'Formular=versandt';
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'Pageview',
                                'url': customUrl,
                            });

                        } else {
                            $('ul.failed', mailsent).show();
                        }
                        $('.progress .done', modDiv).addClass('active');
                    },
                ).fail(function() {
                    $('.div24Loading', mailsent).hide();
                    $('ul.failed', mailsent).show();
                    $('.progress .done', modDiv).addClass('active');
                });
            }
        });
    }
})(jQuery);
